import moment from 'moment-timezone';
import { Autocomplete, TTextType } from '@ts/storybook';
import { memo } from 'react';

interface TimeZoneSelectProps {
  title?: TTextType;
  onChange: (value: string) => void;
  value?: string;
  disabled?: boolean;
  isReadOnly?: boolean;
}

const TimeZoneSelect = ({ title, onChange, value, disabled, isReadOnly }: TimeZoneSelectProps) => {
  const timezones = moment.tz.names();

  const onChangeValue = value => {
    onChange(value.value);
  };
  return (
    <Autocomplete
      label={title ?? 'Select Time Zone'}
      onChangeValue={onChangeValue}
      value={value ? ({ label: value, value: value } as any) : undefined}
      options={timezones.map(timezone => ({
        label: timezone,
        value: timezone,
      }))}
      stProps={{ textInput: { disabled: disabled, isReadOnly: isReadOnly } }}
      disableClearable
    />
  );
};

export default memo(TimeZoneSelect);
